import "./Category.scss";
import image1 from "./c1.jpg";
import image2 from "./c2.jpg";
import image3 from "./c3.jpg";
import image4 from "./c4.jpg";
import image5 from "./c5.jpg";
const Category = () => {
    return (
        <div className="shop-by-category">
            <div className="sec-heading">Categories</div>
            <div className="categories">
                    <div className="category">
                        <div className="category-img">
                        <img src={image1} alt="category loading ..." />
                        </div>
                    </div>
                    <div className="category">
                        <div className="category-img">
                        <img src={image2} alt="category loading ..." />
                        </div>
                    </div>
                    <div className="category">
                        <div className="category-img">
                        <img src={image3} alt="category loading ..." />
                        </div>
                    </div>
                    <div className="category">
                        <div className="category-img">
                        <img src={image4} alt="category loading ..." />
                        </div>
                    </div>
                    <div className="category">
                        <div className="category-img">
                        <img src={image5} alt="category loading ..." />
                        </div>
                    </div>
            </div>
        </div>
    );
};

export default Category;
